// Weekly compound interest on the Savings Jar.
// Per ECONOMY §8: balance after n weeks = deposit × (1 + r)^n  (r = ratePerWeek).
// We model it as TWO ledger rows so the cashflow meter shows interest as passive income
// while the cash stays in savings: +N (interest, passive) and −N (save, capital, into jar).
// Net wallet = 0, savings balance grows by N, ledger reads honestly.

import type { GameState } from '../state/types.js';
import { applyTxn } from '../ledger/append.js';

export function settleSavingsInterest(state: GameState): GameState {
  const { balance, ratePerWeek } = state.savings;
  if (balance <= 0 || ratePerWeek <= 0) return state;

  const interestAmount = balance * ratePerWeek;
  // Step 1: record interest as passive income (wallet +N).
  let s = applyTxn(state, {
    type: 'interest',
    amount: interestAmount,
    category: 'passive',
    note: `Savings interest @ ${(ratePerWeek * 100).toFixed(2)}%/wk`,
  });
  // Step 2: re-deposit straight back into the jar (wallet −N, savings +N).
  s = applyTxn(s, {
    type: 'save',
    amount: -interestAmount,
    category: 'capital',
    note: 'Auto re-deposit of interest',
  });
  return {
    ...s,
    savings: { ...s.savings, balance: s.savings.balance + interestAmount },
  };
}
